import React from 'react';
import { IRouteIconProps } from './Navbar.interfaces';

export function HomeIcon({ fill }: IRouteIconProps) {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0078125 9.06291C0.0078125 9.40643 0.275931 9.7332 0.728382 9.7332C0.962986 9.7332 1.1557 9.60752 1.33165 9.46508L2.42088 8.54342V16.5367C2.42088 17.7097 3.11632 18.3884 4.31447 18.3884H15.6509C16.8407 18.3884 17.5361 17.7097 17.5361 16.5367V8.48477L18.7007 9.46508C18.8683 9.60752 19.061 9.7332 19.2956 9.7332C19.6894 9.7332 20.0078 9.49022 20.0078 9.08804C20.0078 8.83668 19.924 8.66911 19.7481 8.51829L17.5361 6.65821V3.18942C17.5361 2.82076 17.3015 2.58616 16.9328 2.58616H16.0363C15.676 2.58616 15.433 2.82076 15.433 3.18942V4.8903L11.0258 1.18691C10.4058 0.659051 9.63496 0.659051 9.00656 1.18691L0.275931 8.51829C0.0915997 8.66911 0.0078125 8.87019 0.0078125 9.06291ZM12.4335 11.4257C12.4335 11.0403 12.1821 10.7889 11.7967 10.7889H8.24409C7.85029 10.7889 7.59893 11.0403 7.59893 11.4257V17.0394H4.59935C4.06311 17.0394 3.76986 16.7378 3.76986 16.1932V7.4123L9.71875 2.42696C9.90308 2.25939 10.1293 2.25939 10.3136 2.42696L16.1871 7.35365V16.1932C16.1871 16.7378 15.8939 17.0394 15.366 17.0394H12.4335V11.4257Z"
        fill={fill}
      />
    </svg>
  );
}

export function SessionsIcon({ fill }: IRouteIconProps) {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.92691 18.4747H17.6349C19.7322 18.4747 20.7759 17.431 20.7759 15.3638V3.11089C20.7759 1.04365 19.7322 0 17.6349 0H3.92691C1.82957 0 0.775879 1.03362 0.775879 3.11089V15.3638C0.775879 17.441 1.82957 18.4747 3.92691 18.4747ZM3.77638 16.859C2.88325 16.859 2.39153 16.3874 2.39153 15.4541V5.99097C2.39153 5.06774 2.88325 4.58605 3.77638 4.58605H17.7653C18.6585 4.58605 19.1602 5.06774 19.1602 5.99097V15.4541C19.1602 16.3874 18.6585 16.859 17.7653 16.859H3.77638ZM8.81401 8.18866H9.40609C9.75731 8.18866 9.87774 8.08831 9.87774 7.73708V7.14501C9.87774 6.79378 9.75731 6.68339 9.40609 6.68339H8.81401C8.46278 6.68339 8.34236 6.79378 8.34236 7.14501V7.73708C8.34236 8.08831 8.46278 8.18866 8.81401 8.18866ZM12.1557 8.18866H12.7377C13.089 8.18866 13.2094 8.08831 13.2094 7.73708V7.14501C13.2094 6.79378 13.089 6.68339 12.7377 6.68339H12.1557C11.7944 6.68339 11.6841 6.79378 11.6841 7.14501V7.73708C11.6841 8.08831 11.7944 8.18866 12.1557 8.18866ZM15.4874 8.18866H16.0794C16.4307 8.18866 16.5411 8.08831 16.5411 7.73708V7.14501C16.5411 6.79378 16.4307 6.68339 16.0794 6.68339H15.4874C15.1361 6.68339 15.0157 6.79378 15.0157 7.14501V7.73708C15.0157 8.08831 15.1361 8.18866 15.4874 8.18866ZM5.48235 11.4701H6.07442C6.42565 11.4701 6.53604 11.3698 6.53604 11.0186V10.4265C6.53604 10.0753 6.42565 9.97491 6.07442 9.97491H5.48235C5.13112 9.97491 5.0107 10.0753 5.0107 10.4265V11.0186C5.0107 11.3698 5.13112 11.4701 5.48235 11.4701ZM8.81401 11.4701H9.40609C9.75731 11.4701 9.87774 11.3698 9.87774 11.0186V10.4265C9.87774 10.0753 9.75731 9.97491 9.40609 9.97491H8.81401C8.46278 9.97491 8.34236 10.0753 8.34236 10.4265V11.0186C8.34236 11.3698 8.46278 11.4701 8.81401 11.4701ZM12.1557 11.4701H12.7377C13.089 11.4701 13.2094 11.3698 13.2094 11.0186V10.4265C13.2094 10.0753 13.089 9.97491 12.7377 9.97491H12.1557C11.7944 9.97491 11.6841 10.0753 11.6841 10.4265V11.0186C11.6841 11.3698 11.7944 11.4701 12.1557 11.4701ZM15.4874 11.4701H16.0794C16.4307 11.4701 16.5411 11.3698 16.5411 11.0186V10.4265C16.5411 10.0753 16.4307 9.97491 16.0794 9.97491H15.4874C15.1361 9.97491 15.0157 10.0753 15.0157 10.4265V11.0186C15.0157 11.3698 15.1361 11.4701 15.4874 11.4701ZM5.48235 14.7617H6.07442C6.42565 14.7617 6.53604 14.6513 6.53604 14.3V13.708C6.53604 13.3567 6.42565 13.2564 6.07442 13.2564H5.48235C5.13112 13.2564 5.0107 13.3567 5.0107 13.708V14.3C5.0107 14.6513 5.13112 14.7617 5.48235 14.7617ZM8.81401 14.7617H9.40609C9.75731 14.7617 9.87774 14.6513 9.87774 14.3V13.708C9.87774 13.3567 9.75731 13.2564 9.40609 13.2564H8.81401C8.46278 13.2564 8.34236 13.3567 8.34236 13.708V14.3C8.34236 14.6513 8.46278 14.7617 8.81401 14.7617ZM12.1557 14.7617H12.7377C13.089 14.7617 13.2094 14.6513 13.2094 14.3V13.708C13.2094 13.3567 13.089 13.2564 12.7377 13.2564H12.1557C11.7944 13.2564 11.6841 13.3567 11.6841 13.708V14.3C11.6841 14.6513 11.7944 14.7617 12.1557 14.7617Z"
        fill={fill}
      />
    </svg>
  );
}

export function ProfileIcon({ fill }: IRouteIconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.4706 20 20 15.4608 20 10C20 4.52941 15.4608 0 9.9902 0C4.52941 0 0 4.52941 0 10C0 15.4608 4.53922 20 10 20ZM10 13.3431C7.05882 13.3431 4.78431 14.3922 3.79412 15.5686C2.47059 14.098 1.67647 12.1471 1.67647 10C1.67647 5.37255 5.36275 1.66667 9.9902 1.66667C14.6176 1.66667 18.3235 5.37255 18.3333 10C18.3431 12.1471 17.5392 14.098 16.2157 15.5784C15.2255 14.402 12.951 13.3431 10 13.3431ZM10 11.6765C11.8824 11.6961 13.3627 10.0882 13.3627 7.98039C13.3627 6 11.8824 4.35294 10 4.35294C8.11765 4.35294 6.62745 6 6.63726 7.98039C6.64706 10.0882 8.11765 11.6569 10 11.6765Z"
        fill={fill}
      />
    </svg>
  );
}

export function ReportsIcon({ fill }: IRouteIconProps) {
  return (
    <svg
      width="41px"
      height="22px"
      viewBox="0 0 41 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="reportsIcon" stroke={fill}>
          <rect
            id="Rectangle"
            x="0.5"
            y="0.5"
            width="33"
            height="4.81395349"
            rx="1"
          />
          <rect
            id="Rectangle-Copy"
            x="0.5"
            y="8.5"
            width="23.2713178"
            height="4.81395349"
            rx="1"
          />
          <rect
            id="Rectangle-Copy-2"
            x="0.5"
            y="16.3914729"
            width="39.5736434"
            height="4.81395349"
            rx="1"
          />
        </g>
      </g>
    </svg>
  );
}
